import { Injectable } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Entry } from 'contentful';
import { ContentFulModel } from 'src/app/shared/models/contentfulmodel';
import { BehaviorSubject } from 'rxjs';
import { PageId } from 'src/app/shared/utilities/pageids.enum';
import { MetaService } from 'src/app/shared/services/meta.service';

@Injectable({
  providedIn: 'root',
})
export class UsecasepageService {
  private usecaseDataSubject$ = new BehaviorSubject<any>(null);
  public usecaseData$ = this.usecaseDataSubject$.asObservable();

  private connectPageDataSubject$ = new BehaviorSubject<any>(null);
  public connectPageData$ = this.connectPageDataSubject$.asObservable();

  constructor(
    private contentful: ContentfulService,
    private meta: MetaService
  ) {}

  usecaseData: any;
  connectPageDataVal: any;

  getUsecaseByID(query: string): Promise<Entry<any>[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          access_token: PageId.accessToken,
          include: 10,
          content_type: PageId.useCasesPage,
          'fields.id': query,
        })
      )
      .then(res => {
        return res.items;
      });
  }

  getcUsecaseData(id: string): void {
    this.getUsecaseByID(id).then(data => {
      if (data && data.length > 0 && data[0]?.fields) {
        this.usecaseData = data[0].fields;
        this.usecaseDataSubject$.next(this.usecaseData);
      }
    }).catch(error => {
      console.error('Error fetching usecase data:', error);
    });
  }

  getUsecasePageData(id: string): void {
    this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.useCasesPage,
          include: 10,
        })
      )
      .then(res => {
        const mod = res.items as any[];
        this.usecaseData = mod.filter((el: any) => el?.fields?.id === id);
      });
  }
  getUsecasePageAlData(): Promise<any[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.useCasesPage,
          include: 10,
        })
      )
      .then(res => {
        const mod = res.items as any[];
        return mod || [];
      })
      .catch(error => {
        console.error('Error fetching usecase page data:', error);
        return [];
      });
  }
  getVertoConnectPageData(): void {
    this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.vertoConnectPage,
          include: 50,
        })
      )
      .then(connectRes => {
        if (connectRes.items && connectRes.items.length > 0) {
          this.connectPageDataVal = (connectRes.items[0] as any).fields;
          if (this.connectPageDataVal) {
            this.connectPageDataSubject$.next(this.connectPageDataVal);
          }
        }
      });
  }
}
